<div class="w-full h-full bg-pattern flex flex-col items-center justify-center">
  <div @fadeInUp class="card overflow-hidden w-full max-w-md">
    <div class="p-6 pb-0 flex flex-col items-center justify-center">
      <div class="fill-current text-center">
        <img class="w-16" src="assets/img/logo/signet.svg" />
      </div>
    </div>

    <div class="text-center mt-4">
      <h2 class="title m-0">Sign up for an account</h2>
      <h4 class="body-2 text-secondary m-0">Simply fill out the form below</h4>
    </div>

    <div
      [formGroup]="form"
      class="p-6 flex flex-col gap-4 flex-auto flex flex-col"
    >
      <div>
        <mat-form-field class="flex-1 block">
          <mat-label>Email</mat-label>
          <input formControlName="email" matInput required />
          <mat-error *ngIf="form.controls['email'].hasError('required')"
            >We need an email address to log you in
          </mat-error>
          <mat-error *ngIf="form.controls['email'].hasError('email')"
            >Please provide a valid email address
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex-1 block">
          <mat-label>Password</mat-label>
          <input
            [type]="inputType"
            formControlName="password"
            matInput
            required
          />
          <button
            (click)="toggleVisibility()"
            mat-icon-button
            matIconSuffix
            matTooltip="Toggle Visibility"
            type="button"
          >
            <mat-icon *ngIf="visible" svgIcon="mat:visibility"></mat-icon>
            <mat-icon *ngIf="!visible" svgIcon="mat:visibility_off"></mat-icon>
          </button>
          <mat-error *ngIf="form.controls['password'].hasError('required')"
            >We need a password to log you in
          </mat-error>
        </mat-form-field>
      </div>

      <button (click)="signUpWithEmailAndPassword()" color="primary" mat-raised-button type="button">Sign up</button>

      <div class="flex items-center justify-center">
        <h4 class="body-2 text-secondary m-0">or</h4>
      </div>

      <button
        color="google-plus"
        mat-raised-button
        type="button"
        (click)="signUpWithGoogle()"
      >
        <mat-icon [fontIcon]="'fa-google'" class="icon" fontSet="fa"></mat-icon>
        <span>Sign up with Google</span>
      </button>

      <button
        color="facebook"
        mat-raised-button
        type="button"
        (click)="signUpWithFacebook()"
      >
        <mat-icon
          [fontIcon]="'fa-facebook'"
          class="icon"
          fontSet="fa"
        ></mat-icon>
        <span>Sign up with Facebook</span>
      </button>

      <button
        color="twitter"
        mat-raised-button
        type="button"
        (click)="signUpWithTwitter()"
      >
        <mat-icon
          [fontIcon]="'fa-twitter'"
          class="icon"
          fontSet="fa"
        ></mat-icon>
        <span>Sign up with Twitter / X</span>
      </button>

      <div class="flex items-center justify-center">
        <span>
          By signging up you accept the
          <a href="https://www.subscrib.ly/terms-of-service"
            >terms of service</a
          >
          and agree to our
          <a href="https://www.subscrib.ly/privacy-policy">privacy policy</a>.
        </span>
      </div>

      <p class="text-secondary text-center">
        Already have an account?<br />
        <a [routerLink]="['/login']">Sign in here</a>
      </p>
    </div>
  </div>
</div>
